import {ISerializedWizardFocus} from './serializedWizardFocus';

export interface IWizardSavedState {
    history: ISerializedWizardFocus[];
}

export class WizardSavedState implements IWizardSavedState {
    history: ISerializedWizardFocus[];
}